import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../shared';
import { ProjectsService } from '../projects/projects.service';
import { ConfigService } from '../config.service';
import * as async from 'async';

@Injectable()
export class ProjectMember {
  private serviceUrl = ConfigService.serviceUrl;

  constructor (private http: Http, private apiService: ApiService, private projectsService: ProjectsService) {}

  getProjectMembers(projectId: string): Observable<any> {
      return this.http.get(`${this.serviceUrl}/projects/` + projectId + `/members`)
        .map(res => {return this.extractData(res); })
        .catch(this.handleError);
  }

  getProjectMemberList(projectIds: string[]): Observable<any[]> {
    let members = [];
    return new Observable(obs => {
      async.eachSeries(projectIds, (projectId, callback) => {
        this.getProjectMembers(projectId).subscribe(m => {
          members.push.apply(members, m);
          callback();
        });
      }, err => {
        if (err) {
          obs.error(err);
        } else {
          obs.next(members);
        }
        obs.complete();
      });
    });
  }

  createProjectMembers(members: any[]): Observable<any> {
    let newMembers = [];
    return new Observable(obs => {
      async.eachSeries(members, (member, callback) => {
        this.createProjectMember(member).subscribe(u => {
          newMembers.push(u);
          callback();
        }, err => {
          obs.error(err);
          obs.complete();
        });
      }, err => {
        if (err) {
          obs.error(err);
          obs.complete();
        } else {
          obs.next(newMembers);
          obs.complete();
        }
      });
    });
  }

  createProjectMember(member: any): Observable<any> {
      return this.http.post(`${this.serviceUrl}/projects/` + member.project_id + `/members`, member)
        .map(res => {return this.extractData(res); })
        .catch(this.handleError);
  }

  deleteProjectMembers(members: any[]): Observable<any> {
    return new Observable(obs => {
      async.eachSeries(members, (member, callback) => {
        this.deleteProjectMember(member.project_id, member.user_id).subscribe(u => {
          callback();
        }, err => {
          obs.error(err);
          obs.complete();
        });
      }, err => {
        if (err) {
          obs.error(err);
          obs.complete();
        } else {
          obs.next();
          obs.complete();
        }
      });
    });
  }

  deleteProjectMember(projectId: string, userId: string): Observable<any> {
      return this.http.delete(`${this.serviceUrl}/projects/` + projectId + `/members/` + userId).map(resp => {
          return resp;
        }, error => {
          this.handleError(error);
        });
  }

  private extractData(res: Response) {
    let body = res.json();
    return body;
  }

  private handleError (error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/projectmember/projectmember.service.ts